/**
 * Main Layout Component
 * Responsive layout with sidebar, header, and content area
 */

import { Layout } from 'antd';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { Footer } from '../Footer';
import { PageContainer } from '../../common';
import RevisionRequestBanner from '../../common/RevisionRequestBanner/RevisionRequestBanner';
import './MainLayout.scss';

const { Content } = Layout;

export interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  containerPadding?: 'none' | 'sm' | 'md' | 'lg';
}

/**
 * Main Layout Component
 * 
 * @example
 * ```tsx
 * <MainLayout>
 *   <YourPageContent />
 * </MainLayout>
 * ```
 * 
 * @example
 * ```tsx
 * <MainLayout fullWidth>
 *   <YourFullWidthPageContent />
 * </MainLayout>
 * ```
 */
export const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  className = '',
  fullWidth = false,
  containerPadding = 'lg',
}) => {

  return (
    <Layout className={`main-layout ${className}`}>
      <Sidebar />
      
      <Layout className="main-layout__main">
        <Header />

        <Content className="main-layout__content">
          <PageContainer 
            maxWidth={fullWidth ? 'full' : 'xl'} 
            padding={containerPadding}
          >
            <RevisionRequestBanner />
            {children}
          </PageContainer>
        </Content>
        
        <Footer />
      </Layout>
    </Layout>
  );
};

export default MainLayout;

